export default "__VITE_ASSET__D4B98abx__"